<script setup lang="ts">
	import { ref, computed, watch } from 'vue';
	import AutocompleteInput from '@/vue/form/AutocompleteInput.vue';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const props = defineProps({
		endpoint: String,
		onlyMag: String,
		lastMag: String
		//lastZip: String,
	});
	
	const mag = ref(props.lastMag);
	if (props.onlyMag) {
		mag.value=props.onlyMag;
	}
	const zip = ref("");
	//const zip = ref(props.lastZip);
	const allTitles = ref([]);
	const autocompelteInput = ref(null);		
			
	const emit = defineEmits(['showVendors']);
	
	const titles = computed<[]>(() => {
		if (!magSelected.value) return allTitles.value;
		return allTitles.value.filter((title) => title.mag===mag.value);
	});
			
	const magSelected = computed<boolean>(() => {
		return mag.value!=="";
	});
	
	const zipSelected = computed<boolean>(() => {
		return zip.value!=="";
	});

	const selectEnabled = computed<boolean>(() => {
		return props.onlyMag?false:true;
	});
	
	watch(mag, (newMag: string) => {
		//zip.value="";
		zip.value="";
	});
	
	function showVendors(): void {
		fetchGet("./api/plugins/esprit/vendors?mag="+mag.value+"&zip="+zip.value)
		.then(data => {
			if (data.vendors) {
				emit('showVendors',data.vendors, mag.value, zip.value);
			}
		});
	}
	
	function fetchGet(url) {
		console.log("Fetching url:"+url);
		return fetch(url)
			.then(response => response.json())
			.then(data => {
				//console.log("Loaded data:"+JSON.stringify(data));
				return data;
			})
			.catch((error) => {
				console.log("error :"+error);
			});
	}
		
	//on created
	fetchGet("./api/plugins/esprit/lists?list=titles")
		.then(data => {
			allTitles.value=data.items;
		});
	
</script>
<template>
	<div>
		<p v-if="!magSelected">Označ, který časopis chceš vyhledat.</p>
		<p v-else>Časopis vybrán</p>
		<span class='espritTitles'>
			<span v-for="title in titles" :key="title.id" class="espritTitle">
				<img :src='title.url' @click="mag=title.mag" class="espritTitleImg" />
				<sym-icon name="close" v-show="magSelected && selectEnabled" class="close-cross-vendor activeclick" @click="mag='';" />
			</span>
		</span>
	</div>
	<transition name="fade">
		<div v-if="magSelected" style="padding-top: 20px;">
			<div>Zadej PSČ, kde hledáš časopis.</div>
			<div style="padding-top: 10px;">
				<autocomplete-input ref="autocompelteInput" title="PSČ" rest-api="./api/plugins/esprit/zipcodes/suggest" :size="32" :tabindex="10"
					placeholder="PSČ" :suggest-empty="true" :focus="true" v-model="zip" :params="mag" mode="pick" />
			</div>
		</div>
	</transition>
	<transition name="fade">
		<div  style="padding-top: 20px;">
			<button v-if="zipSelected" @click="showVendors">Zobrazit na mapě</button>
		</div>
	</transition>		
</template>

<style>
	.espritTitles {
	  display: flex; 
	  flex-direction: row;
	  justify-content: flex-start;
	  flex-wrap: wrap;
	  gap: 20px;
	}
	
	.espritTitle {
		display: flex; 
		flex-flow: row nowrap;
		align-items: flex-start;
		gap: 5px;
	}
	
	.espritTitleImg {
		max-width:180px;
		cursor: pointer;
	}

	/**** !!!! Tento styl přejmenován z .close-cross na .close-cross-vendor (styly zde kolidují se standardními styly v projektu) */
	.close-cross-vendor {
		font-size: 18px;
		color: var(--red);
	}
</style>
